import styled from "styled-components";

import { theme } from "../../themes/themes";
export const RowComments = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  width: 22.5vw;
  background-color: ${({ isOwnerCase }) =>
    isOwnerCase ? "#D9D9D980" : "inherit"};
  border-radius: 10px;
  margin: 1em 0;
  padding: 1.5em 1em 1em;
`;

export const ColContentCommentRight = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
`;

export const ColContentCommentProfile = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ColContentCommentLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 68%;
  #comment-description {
    font-size: 12px;
    width: 12.5vw;
  }
`;

export const ContentDate = styled.p`
  display: flex;
  justify-content: ${({ idCaseComment }) =>
    idCaseComment ? "flex-end" : "inherit"};
  align-items: ${({ idCaseComment }) =>
    idCaseComment ? "flex-end" : "inherit"};
  font-size: 12px;
  color: #a5a5a5;
`;

export const ContentText = styled.p`
  font-size: 12px;
  width: 13.5vw;
  color: ${({ theme }) => theme.neutral.black};
  text-align: justify;
`;

export const ContentUser = styled.p`
  display: flex;
  justify-content: ${({ idCaseComment }) =>
    idCaseComment ? "flex-end" : "inherit"};
  align-items: ${({ idCaseComment }) =>
    idCaseComment ? "flex-end" : "inherit"};
  font-size: 12px;
  color: #a5a5a5;
`;

export const ContentIcons = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 2em 2em 1fr;
  svg {
    width: 0.7em;
  }
`;

export const ContentCommentProfile = styled.div`
  margin: ${({ idCaseComment }) => (idCaseComment ? "1em 0em 0em" : "inherit")};
  width: 3em;
  height: 3em;
`;

export const ImgProfile = styled.img`
  width: 2em;
  height: 2em;
  border-radius: 99px;
`;
